import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useId } from "react";
import { useTranslation } from "react-i18next";
import { MAP_STYLE_KEYS, MapStyleKey } from "../models/mapStyles";

interface Props {
  value: MapStyleKey;
  onChange: (mapStyle: MapStyleKey) => void;
}

/**
 * The picker for the map a route or a fleet is drawn on.
 *
 * One control for both maps, and one stored choice behind it: a reader who switches the live map
 * to the plain OpenStreetMap for its yard detail wants the route on the same thing, not on
 * whatever the other page happens to default to.
 */
export function BasemapSelect({ value, onChange }: Props) {
  const { t } = useTranslation();
  // Generated, because the label points at the field by id and both maps can be on screen at once.
  const labelId = useId();
  const label = t("map.settings.basemap");

  return (
    <FormControl size="small" fullWidth>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        label={label}
        value={value}
        onChange={event => onChange(event.target.value as MapStyleKey)}
      >
        {MAP_STYLE_KEYS.map(key => (
          <MenuItem key={key} value={key}>
            {t(`map.settings.basemapName.${key}`)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
